/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DialogContainer from '../../../../../components/shared/Dialog/DialogContainer';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { createSplunkUser } from '../../../../../services/splunk/splunkController';
import SplunkUserCreationForm from './SplunkUserCreationForm';
import { getAllSplunkUsers } from '../../../../../store/reducers/splunk/splunkAction';
const SplunkUserCreation = () => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);



    // Handle form submission
    const handleSubmit = async (values) => {
        try {
            await createSplunkUser({
                "name": values.username,
                "password":  values.password,
                "roles": [
                     values.role
                ],
                "email":  values.email,
                "realname":  values.realname,
                "tz": "America/New_York",
                "force-change-pass": false
            });
            toast.success('User was created successfully');
            await dispatch(getAllSplunkUsers()).unwrap();

            handleClose();

        } catch (error) {
            toast.error(error?.response?.data?.error?.message);

            handleClose();

        }
    };
    return (
        <>
            <Button variant="contained" color="primary" style={{ float: 'right' }} onClick={handleOpen}>Add user</Button>
            {/* Dialog for Adding User */}
            <DialogContainer
                open={open}
                handleClose={handleClose}
            >
                <Box sx={{ mt: 2 }}>
                    <Formik
                        initialValues={{
                            username: '',
                            email: '',
                            role: "",
                            realname: '',
                            password: '',
                            confirmPassword: '',

                        }}
                        validationSchema={Yup.object().shape({
                            username: Yup.string().required('Getchkd user is required.'),
                            realname: Yup.string().required('Real Name is required.'),
                            confirmPassword: Yup.string().min(8).max(30).oneOf([Yup.ref('password'), null], 'Passwords must match').required('password is required'),
                            email: Yup.string().email().required('Email is required.'),
                            role: Yup.string().required('Role is required.'),
                            password: Yup.string().min(6).max(40).required('Password is required.'),
                        })}
                        onSubmit={(
                            values
                        ) => {
                            handleSubmit(values)
                        }
                        }
                    >
                        {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                            <SplunkUserCreationForm
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                isSubmitting={isSubmitting}
                                handleClose={handleClose}
                                errors={errors}
                                touched={touched} />)}
                    </Formik>
                </Box>

            </DialogContainer>
        </>
    )

}

export default SplunkUserCreation;
